import React, { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Table, Input, Select, Tooltip } from "antd";
import { Collapse } from "antd";
import { getRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
const { Panel } = Collapse;

const PurchaseDetailsinHistory = ({ PRid }) => {
  const [siteName, setSiteName] = useState([]);
  const [pincodeList, setPincodeList] = useState([]);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [view, setView] = useState("");

  const { t } = useTranslation();
  const { comId, id, prId } = useParams();
  const formRef = useRef();
  const [tableData, setTableData] = useState([]);

  const [stateWBS, setStateWBS] = useState([]);
  const [state, setState] = useState([]);
  const [siteWiseTotalAmount, setSiteWiseTotalAmount] = useState({
    siteName: "",
    total: "",
  });

  const [siteTotalQuantities, setSiteTotalQuantities] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [cityLength, setCityLength] = useState(1);
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [apiLoading, setapiLoading] = useState(false);
  const [prView, setPRView] = useState(null);

  const getSubCategory = async () => {
    setapiLoading(true);
    try {
       const fields = [
        "id",
        "pr_number",
        "pr_created_date",
        "category_tree_name",
        "pr_type",
        "city_site_material_data"
      ].join(",");
      const queryParams = new URLSearchParams();
      queryParams.set("fields", fields);
      let apiResponse = await getRequest(`purchase-requisition/${PRid}/?${queryParams.toString()}`);
      if (apiResponse.data.success) {
        setState(apiResponse.data.data);
        setPRView(apiResponse?.data?.data?.pr_type);

        const prType = apiResponse.data.data.pr_type || "Material Wise";
        setView(prType);
        formRef.current.setFieldsValue({
          pr_view: prType,
        });
      }

      if (apiResponse.data.data) {
        const purchaseRequisitionDetails = apiResponse.data.data.map(
          (item) => {}
        );
        setState((prevState) => ({
          ...prevState,
          purchase_requisition_details: purchaseRequisitionDetails,
        }));
        const uniqueSubCategories = Array.from(
          new Set(apiResponse.data.data.map((item) => item.sub_category))
        );
        setSubCategoryList(uniqueSubCategories);
        setSubCategoryData(apiResponse.data.data);
        setapiLoading(false);
      } else {
        ErrorNotificationMsg(t("error_in_company_adress_list"));
      }
      setapiLoading(false);
    } catch (error) {
      setapiLoading(false);
    }
  };

  useEffect(() => {
    getSubCategory();
  }, [id, prId]);

  let updateTableData = [];

  updateTableData = (state) => {
    const tableData = [];
    const length = state?.city_site_material_data?.length;
    setCityLength(length);
    let totalCityOfAllSite = 0;
    state?.city_site_material_data?.forEach((city, cityIndex) => {
      const cityRowSpan = city.site_wise_pr.length;
      let cityTotalQuantity = 0;
      let cityTotalQuantityByKg = 0;
      let cityTotal = 0;
      let cityAmount = 0;

      city.site_wise_pr.forEach((site, siteIndex) => {
        let siteTotalQuantity = 0;
        let siteTotalQuantityForKG = 0;
        let siteMaterialTotal = 0;
        let siteMaterialTotalkgg = 0;

        let siteMaterialTotalWithKG = 0;

        site.site_total_quantity += siteTotalQuantity;

        let siteAmount = 0;

        site.pr_material_details?.forEach((material) => {
          console.log('madddterial', material);
          if (material.pr_material_type_name.includes("Sand") && material.pr_material_type_uom_name === "Cum.") {
            siteMaterialTotalkgg +=
              material.pr_material_type_quantity_by_kg *
              material.estimated_material_unit_price;
          } else if (material.pr_material_type_name.includes("Aggregate") && material.pr_material_type_uom_name === "Cum.") {
            siteMaterialTotalkgg +=
              material.pr_material_type_quantity_by_kg *
              material.estimated_material_unit_price;
          } else if (material.pr_material_type_name.includes("Dust") && material.pr_material_type_uom_name === "Cum.") {
            siteMaterialTotalkgg +=
              material.pr_material_type_quantity_by_kg *
              material.estimated_material_unit_price;
          }
          else if (material.pr_material_type_uom_name === "MT") {
            siteMaterialTotalkgg +=
              material.pr_material_type_quantity *
              1000 *
              material.estimated_material_unit_price;
          } else if (material.pr_material_type_uom_name === "Bag") {
            siteMaterialTotalkgg +=
              material.pr_material_type_quantity *
              50 *
              material.estimated_material_unit_price;
          } else {
            siteMaterialTotalkgg +=
              material.pr_material_type_quantity *
              material.estimated_material_unit_price;
          }

          siteTotalQuantity += material.pr_material_type_quantity;
          siteMaterialTotal +=
            material.pr_material_type_quantity *
            material.estimated_material_unit_price;

          if (material.pr_material_type_uom_name === "Cubic Meter") {
            siteMaterialTotalWithKG +=
              material.pr_material_type_quantity *
              material.estimated_material_unit_price;
          } else {
            siteMaterialTotalWithKG +=
              material.pr_material_type_quantity_by_kg *
              material.estimated_material_unit_price;
          }

          siteTotalQuantityForKG += material.pr_material_type_quantity_by_kg;
          siteAmount +=
            material.pr_material_type_quantity *
            material.estimated_material_unit_price;
        });
        site.site_total_quantity = siteTotalQuantity;
        setSiteTotalQuantities((prevQuantities) => [
          ...prevQuantities,
          siteTotalQuantity,
        ]);

        cityTotalQuantity += siteTotalQuantity;
        cityTotal += siteMaterialTotalWithKG;
        cityTotalQuantityByKg += siteTotalQuantityForKG;
        cityAmount += siteMaterialTotalWithKG;
        totalCityOfAllSite += siteMaterialTotalkgg;

        tableData.push({
          key: `${cityIndex}-${siteIndex}`,
          srNo:
            length > 1
              ? siteIndex === 0
                ? cityIndex + 1
                : null
              : siteIndex + 1,
          cityName: siteIndex === 0 ? city.city_name : null,
          cityRowSpan: siteIndex === 0 ? cityRowSpan : 0,
          siteName: site.site_name,
          siteLocations: site.pr_material_details?.map((material, matIndex) => {
            return {
              availableBudget: material.available_budget || 0,
              estimatedPRValue: 185 || 0,
              remark: material.remark,
              materialName: material.pr_material_type_name,
              quantity: material.pr_material_type_quantity,
              quantityForKG: material.pr_material_type_quantity_by_kg,
              uom: material.pr_material_type_uom_id,
              uom_name: material.pr_material_type_uom_name,
              subCategory: material.pr_material_type_sub_category,
              siteIndex,
              matIndex,
              cityId: city.city_name,
              siteId: site.pr_site_id,
              estimatedPrice: material.estimated_material_unit_price,

              amount:
                material.pr_material_type_uom_name === "Cubic Meter"
                  ? material.pr_material_type_quantity *
                    material.estimated_material_unit_price
                  : material.pr_material_type_quantity_by_kg *
                    material.estimated_material_unit_price,
            };
          }),
          totalAmount: <Input disabled className="site-subtotal" />,
        });

        tableData.push({
          key: `${cityIndex}-${siteIndex}-SiteSubTotal`,
          siteName: "Site Sub-Total",
          siteLocations: [
            {
              totalQuantity: siteMaterialTotal,
              materialName: "",
              quantity: siteTotalQuantity,
              quantityForKG: siteTotalQuantityForKG,
              subCategory: "",
              siteIndex,
              matIndex: 0,
              cityId: city.city_id,
              siteId: site.site_id,
              amount: siteMaterialTotalWithKG,
            },
          ],
          totalAmount: (
            <Input
              disabled
              value={`\u20B9 ${siteTotalQuantity || 0}`}
              className="site-subtotal"
            />
          ),
          siteTotalQuantity: (
            <Input
              disabled
              value={siteTotalQuantity || 0}
              className="site-total-quantity"
              readOnly
            />
          ),
        });

        if (length > 1) {
          if (siteIndex === city.site_wise_pr.length - 1) {
            tableData.push({
              key: `${cityIndex}-${siteIndex}-CityTotal`,
              siteName: "City Total",
              siteLocations: [
                {
                  materialName: "",
                  cityTotal: cityTotal,
                  quantity: cityTotalQuantity,
                  quantityForKG: cityTotalQuantityByKg,
                  subCategory: "",
                  siteIndex,
                  matIndex: 0,
                  cityId: city.city_id,
                  siteId: site.site_id,
                  amount: cityAmount,
                },
              ],
              totalAmount: (
                <Input
                  disabled
                  value={`\u20B9 ${cityTotalQuantity || 0}`}
                  className="subtotal"
                  readOnly
                />
              ),
              cityTotalQuantity: (
                <Input
                  disabled
                  value={city.city_total_quantity || 0}
                  className="city-total-quantity"
                  readOnly
                />
              ),
            });
          }
        }
      });

      city.city_total_quantity = cityTotal;
    });
    tableData.push({
      key: `Total`,
      siteName: `Total`,
      siteName1: "Total",
      siteLocations: [
        {
          materialName: "",
          cityTotal: "",
          quantity: "",
          totalCityOverallSite: totalCityOfAllSite,
          cityQuantityForKG: "",
          cityTotalAmountForKG: "",
          subCategory: "",
          siteIndex: 0,
          matIndex: 0,
          // cityId: city.city_id,
          // siteId: site.site_id,
        },
      ],
      totalAmount: <Input disabled value="₹ 0" className="subtotal" readOnly />,
      totalQuantity: (
        <Input disabled value="0" className="city-total-quantity" readOnly />
      ),
    });

    setTableData(tableData);
  };

  useEffect(() => {
    updateTableData(state);
  }, [state]);

  const wbsBudget = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      fixed: "left",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      fixed: "left",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    },
    {
      title: "Available Budget",
      dataIndex: "siteLocations",
      width: 150,
      render: (siteLocations, record) => {
        if (record.siteName !== "City Total" && record.siteName !== "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              <div key={1} className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "100%" }}
                  readOnly
                  value={1000000}
                />
              </div>
            </div>
          );
        }
        return null;
      },
    },
    {
      title: "Estimated PR Value",
      dataIndex: "siteLocations",
      width: 150,
      render: (siteLocations, record) => {
        if (record.siteName === "City Total" || record.siteName === "Total") {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              <div className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "100%" }}
                  value={siteLocations[0].cityTotal}
                  readOnly
                />
              </div>
            </div>
          );
        } else {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginRight: "20px",
              }}
            >
              <div key={1} className="lblvalue">
                <Input
                  addonBefore={currencySymbol}
                  type="number"
                  min={0}
                  style={{ width: "100%" }}
                  value={siteLocations[0].estimatedPRValue}
                  readOnly
                />
              </div>
            </div>
          );
        }
      },
    },
  ];

  if (cityLength > 1) {
    wbsBudget.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 150,
      render: (text) => <div className="lblvalue">{text}</div>,
    });
  }

  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      fixed: "left",
      width: 50,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      fixed: "left",
      width: 150,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return <div className="subtotal">{"Sub total"}</div>;
        } else if (record.siteName === "City Total") {
          return <div className="citytotal">{"City total"}</div>;
        } else if (record?.key?.includes("Total")) {
          return (
            <div className="totalCityOverallSitee4">{record.siteName1}</div>
          );
        } else {
          return <>{record.siteName}</>;
        }
      },
    },
    {
      title: "Item",
      dataIndex: "siteLocations",
      fixed: "left",
      width: 200,
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.materialName}
              </div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "siteLocations",
      fixed: "right",
      width: 130,
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          return <></>;
        } else if (record.siteName === "City Total") {
          return <></>;
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {siteLocations.map((site, index) => (
                  <div key={index} className="lblvalue">
                    {site.quantity}
                  </div>
                ))}
              </div>
            </>
          );
        }
      },
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Preferred Unit of measurement means Your company buys material
              generally in this unit of measurement
            </span>
          }
        >
          Preferred UoM.
        </Tooltip>
      ),
      width: 120,
      dataIndex: "siteLocations",
      render: (siteLocations, record) => {
        const defaultOption = pincodeList.find(
          (option) => option.unit_of_measurement === "MT"
        );
        const defaultValue = defaultOption ? defaultOption.id : 1;
        if (
          record.siteName === "City Total" ||
          record.siteName === "Site Sub-Total"
        ) {
          return "";
        }
        return (
          <>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {siteLocations.map((site, index) => (
                <div
                  key={index}
                  className="lblvalue"
                >
                  {/* {site.uom} */}
                  {site?.uom_name === "Cubic Meter" ? "Cu. Mtr." : site?.uom_name}
                </div>
              ))}
            </div>
          </>
        );
      },
    },
    {
      title: "Qty. In Kg",
      dataIndex: "siteLocations",
      width: 100,
      align: "right",
      render: (siteLocations, record) => {
        if (record.siteName === "Site Sub-Total") {
          // return (
          // );
        } else if (record.siteName === "City Total") {
          // return (
          // );
        } else {
          return (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                  marginRight: "5px",
                }}
              >
                {siteLocations.map((site, index) => {
                  return (
                    <div key={index} className="">
                      {site.quantityForKG == 0
                        ? "-"
                        : site.quantityForKG?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })}
                    </div>
                  );
                })}
              </div>
            </>
          );
        }
      },
    },
    {
      title: "Est. Amount",
      dataIndex: "amount",
      key: "amount",
      width: 150,
      align: "right",

      render: (text, record) => {
        if (record.siteName === "Site Sub-Total") {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                className="subtotal"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                }}
              >
                {record.siteLocations.map((site, index) => {
                  return (
                    <div key={index} className="">
                      ₹{" "}
                      {site.amount
                        ? site.amount?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        } else if (record.siteName === "City Total") {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                className="citytotal"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                }}
              >
                {record.siteLocations.map((site, index) => {
                  return (
                    <div key={index} className="">
                      ₹{" "}
                      {site.amount
                        ? site.amount?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        } else if (record.siteName1 === "Total") {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                className="totalCityOverallSite"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  float: "inline-end",
                }}
              >
                {record.siteLocations.map((site, index) => {
                  return (
                    <div key={index} className="">
                      ₹{" "}
                      {site.totalCityOverallSite
                        ? site.totalCityOverallSite?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        } else {
          if (record.siteLocations && Array.isArray(record.siteLocations)) {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  alignItems: "flex-end",
                  marginRight: "5px",
                }}
              >
                {record.siteLocations.map((site, index) => {
                  return (
                    <div key={index} className="lblvalue">
                      ₹{" "}
                      {site.amount
                        ? site.amount?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          })
                        : 0}
                    </div>
                  );
                })}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Remarks",
      dataIndex: "siteLocations",
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.remark}
              </div>
            ))}
          </div>
        </>
      ),
    },
  ];

  if (cityLength > 1) {
    columns.splice(1, 0, {
      title: "City",
      dataIndex: "cityName",
      key: "cityName",
      width: 150,
      render: (text, record, index) => {
        if (index === 0 || record.cityName !== tableData[index - 1].cityName) {
          return <div className="lblvalue">{text}</div>;
        } else {
          return <div className="lblvalue" />;
        }
      },
    });
  }

  const theadPR = <Table columns={columns} />;

  const colors = ["#094E8F"];
  return (
    <>
      {
        <>
          <Collapse defaultActiveKey={["1"]} className="scroll2">
            <Panel header={theadPR} key="1">
              <Table
                loading={apiLoading}
                columns={columns}
                dataSource={tableData}
                pagination={false}
                scroll={{ x: "auto" }}
              />
            </Panel>
          </Collapse>
        </>
      }
    </>
  );
};

PurchaseDetailsinHistory.propTypes = {
  PRid: PropTypes.number,
};

export default PurchaseDetailsinHistory;
